import { render } from "./representante-fatca.vue?vue&type=template&id=3f46dcee"
import script from "./representante-fatca.vue?vue&type=script&lang=js"
export * from "./representante-fatca.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__